import { Injectable } from '@angular/core';

@Injectable()
export class SettingsFocusService {
  private returnLabel = '';

  public remember(label: string): void {
    this.returnLabel = label;
  }

  public consume(): string {
    const label = this.returnLabel;
    this.returnLabel = '';
    return label;
  }
}
